import utils from '@/utils/utils.js';
import Vue from "vue";

export const checkButtonPermission = {
  name: "check-button-permission",
  callback: {
    inserted: function(el, binding, vnode) {
      el.addEventListener('click', function(event) {
        const data = binding.value;
        // 根据条件决定是否阻止点击事件
        if (!utils.checkButtonPermission(data.perms)) {
          event.preventDefault();
          event.stopPropagation();
          Vue.prototype.$toast.showToast(Vue.prototype.bus.$t("common.noPermission"), "error");
        } else if (typeof data.handleClick === 'function') {
          data.handleClick(event);
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/directive/index.js